/* @flow */

import type { ReadOnlyKeyValuePair } from '../jsHelpers/types';

export const StorageKeys: ReadOnlyKeyValuePair<string> = Object.freeze({
  CardExpandedItemIndex: 'cardExpandedItemIndex',
  CrmData: 'crmData',
  DataCollectionStash: 'dataCollectionStash',
  DefaultSubtitlesApplied: 'defaultSubtitlesApplied',
  DeviceIdentifier: 'deviceIdentifier',
  DeviceRestrictions: 'deviceRestrictions',
  FcmToken: 'fcmToken',
  LastBOTokenRenewal: 'boTokenRenewalLast',
  LastPaymentExpirationNotification: 'lastPaymentExpirationNotification',
  LastProfileId: 'lastProfileId',
  LastStartup: 'startupLast',
  LastTokenRenewal: 'tokenRenewalLast',
  LastViewingHistoryCleanUp: 'lastViewingHistoryCleanUp',
  NextBOTokenRenewal: 'boTokenRenewalNext',
  NextTokenRenewal: 'tokenRenewalNext',
  NextVersionCheckDate: 'nextVersionCheckDate',
  OptimisticDmsSettings: 'optimisticDmsSettings',
  OptimisticDmsSettingsEnabled: 'optimisticDmsSettingsEnabled',
  OverriddenAppConf: 'overriddenAppConf',
  PendingOperation: 'pendingOperation',
  PrefersReducedMotion: 'prefersReducedMotion',
  ProfileIds: 'profileIds',
  RegisteredAsGuest: 'registeredAsGuest',
  SearchHistory: 'searchHistory',
  Settings: 'settings',
  StartupProfileId: 'startupProfileId',
  UserDeviceInfo: 'userDeviceInfo',
});
